module.exports = __webpack_public_path__ + "r-v3/img/ico_room_info_white.2ca7bf05.svg";